<template>
  <div class="product-rating" v-if="hasRating()" @click="scrollToRatings">
    <Rating :rating="rating" />
    <label>({{ratingsCount}})</label>
    <label class="mobile-text">({{ratingsCount}})</label>
  </div>
</template>
<script>
import Rating from '@/components/Rating'

export default {
  props: ['rating', 'ratingsCount'],

  components: {
    Rating
  },

  methods: {
    hasRating () {
      return this.ratingsCount > 0
    },
    scrollToRatings () {
      let tab = document.getElementsByClassName('product-tabs__item')
      let myContentPanes = document.querySelectorAll('.product-tabs > div')
      for (var i = 0; i < tab.length; i++) {
        if (tab[i].hash === '#productRatings') {
          tab[i].classList.add('active')
        } else {
          tab[i].classList.remove('active')
        }
      }
      for (i = 0; i < myContentPanes.length; i++) {
        console.log()
        if (myContentPanes[i].getAttribute('id') === 'productRatings') {
          myContentPanes[i].classList.add('active')
          myContentPanes[i].getElementsByClassName('c-product-desc__trigger')[0].classList.add('active')
          myContentPanes[i].getElementsByClassName('l-opinions')[0].classList.add('active')
        } else {
          myContentPanes[i].classList.remove('active')
        }
      }
      const el = document.getElementById('productRatings')
      const y = el.getBoundingClientRect().top - 100
      window.scrollTo({top: y, behavior: 'smooth'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductPage/ProductRating.vue